module.exports = __webpack_public_path__ + "static/media/J (1).a9e1dd17.jpg";